/**
 * GalleryContainer Component
 * Slideshow controller.
 */
require('../styles/slideshow.scss');

import React from 'react';
import {connect} from 'react-redux';
import store from '../store';
import actions from '../actions/galleryActions';

import Photos from './Photos';
import ImageGallery from 'react-image-gallery';

// Every time the state changes, log it
// Note that subscribe() returns a function for unregistering the listener

class GalleryContainer extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.photos.map(function(photo){
      if(photo.original.indexOf('/media/') === -1){
        photo.original = '/media/'+ photo.original;
      }
      return photo;
    });
  }

  componentDidMount() {
    window.addEventListener('keydown', this._listenForEsc.bind(this), true);
  }

  componentWillUnMount() {
    window.addEventListener('keydown', this._listenForEsc.bind(this), true);
  }

  close () {
    store.dispatch(actions.GALLERY_CLOSE);
  }

  _listenForEsc (event) {
    if (
      this.props.keyboard &&
        (event.key === 'Escape' ||
        event.keyCode === 27)) {
      this.close();
    }
  }

  slideToIndex (index) {
    this._imageGallery.slideToIndex(index)
  }

  photoClicked (index) {
      store.dispatch(actions.GALLERY_UPDATE_CURRENT_SLIDE(index));
      store.dispatch(actions.GALLERY_OPEN);
      this._imageGallery.slideToIndex(index);
  }

  render() {
    // called when component is rendered
    return (
      <div>
        <Photos
          photos={this.props.photos}
          onPhotoClick={this.photoClicked.bind(this)} />

        <div className={this.props.open ? 'slideshow--popup open' : 'slideshow--popup closed'} >
          <div className="slideshow-overlay" onClick={this.close} ></div>

          <div className="image-gallery-container">
            <div className="slideshow__close" onClick={this.close}></div>
            <ImageGallery
              ref={i => this._imageGallery = i}
              items={this.props.photos}
              showThumbnails={false}
              autoPlay={false}
              fullscreen={true}
              showPlayButton={false}
              showFullscreenButton={false}
              startIndex={this.props.currentSlide}
              renderItem={ function(item) {

                return (
                  <div className='image-gallery-image' style={{ backgroundImage: 'url('+item.original+')' }}>
                    <img
                        src={item.original}
                        alt={item.originalAlt}
                        srcSet={item.srcSet}
                        sizes={item.sizes}
                    />
                    {
                      item.description && item.title &&
                        <div className='image-gallery-description'>
                          <div className="image-gallery-description__title">{item.title}</div>
                          <div className="image-gallery-description__description">{item.description}</div>
                        </div>
                    }
                  </div>
                )
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

GalleryContainer.propTypes = {
  open: React.PropTypes.bool,
  currentSlide: React.PropTypes.number,
  keyboard: React.PropTypes.bool
};

GalleryContainer.defaultProps = {
  open: false,
  currentSlide: 0,
  keyboard: true
};

const mapStateToProps = function(store){
  return {
    open: store.gallery.open,
    currentSlide: store.gallery.currentSlide
  }
}

export default connect(mapStateToProps)(GalleryContainer);



// WEBPACK FOOTER //
// ./src/components/GalleryContainer.js